module.exports = __webpack_public_path__ + "explore/images/eoy/top-publishers/prevention-2x.6f6cca49780c5310123242fe9376d86e.png";